import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { reorderTags } from "../../services/tags";

interface IPayload {
    tagId: number;
    action: 'up' | 'down';
};

const useReorderTags = () => {
    const queryClient = useQueryClient();

    const mutationFn = async (payload: IPayload) => {
        return await reorderTags(payload.tagId, payload.action);
    };

    return useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['tags'] });
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.message);
        }
    });
};

export default useReorderTags;